.container {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  width: 100%;
  padding: 1rem;
  overflow: hidden;
  gap: 1rem;
}

.card {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  padding: 1rem;
  max-width: 546px;
  text-align: center;
  font-size: 14px;
  background-color: rgb(250, 250, 250);
  box-shadow: 2px 2px 12px 0 rgba(0, 0, 0, 0.05);
  box-shadow: 0 4px 4px 0 rgba(0, 0, 0, 0.05);
  transition: all 0.3s ease;
  composes: slideLeft from global;
}
.card:hover {
  box-shadow: 0 2px 4px rgba(0, 0, 0, 1);
  color: black;
  transform: scale(1.02);
}

.header {
  display: flex;
  justify-content: space-between;
}

.action {
  font-family: Gantari;
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  text-align: left;
}

.divider {
  width: 100%;
  border-bottom: 1px solid #d9d9d9;
}

.body {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  text-align: left;
  gap: 0.1rem;
}

.history {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: space-between;
  width: 100%;
  gap: 1rem;
}

.footer {
  gap: 0.5rem;
  display: flex;
  justify-content: flex-end;
}
